
define('app/board/views/headerInfoView',[
	'jquery',
	'underscore',
	'backbone',
	'app/board/collections/pickSummaryCollection',
	'app/board/models/draftStatusModel',
	'known/models/leagueInstanceModel',
	'known/models/userModel'
], function($, _, Backbone, PickSummaryCollection, DraftStatusModel, LeagueInstanceModel, UserModel){
	var HeaderInfoView = Backbone.View.extend({
		initialize: function(options) {
			this.draftStatus = options.draftStatus;			
			this.leagueInstance = options.leagueInstance;
			this.pickSummaryCollection = options.pickSummaryCollection;
			this.user = options.user;
			this.prodConfig = options.prodConfig;
			this.pickCollection = options.pickCollection;
			
			this.user.bind("change", this.pickOwnerRender, this);
			this.draftStatus.bind("change", this.render, this);
			
			if($(this.el).has('#currentPickHeaderPickPlayerBtn').length){
				this.shareBtnContainer = $(this.el).find('#currentPickHeaderShareBtn');
				this.draftBtnContainer = $(this.el).find('#currentPickHeaderPickPlayerBtn');
				this.draftBtn = $(this.el).find('#currentPickHeaderPickPlayerBtn');
				
				if(this.leagueInstance.get('draftType') == 'AUCTION'){
					this.draftBtnContainer.html('Nominate Player');
					this.draftBtnContainer.addClass('bidding');
					$(this.el).find('.currentPickUserLabel').hide();
					$(this.el).find('.currentPickNumLabel').hide();
					$(this.el).find('.currentPickRoundLabel').hide();
				}
			} else {
				this.shareBtnContainer = $('#draftBoardHdrShare');
				this.draftBtnContainer = $('#draftBoardHdrPickPlayer');
				this.draftBtn = $('#draftBoardHdrPickPlayerBtn');
				
				if(this.leagueInstance.get('draftType') == 'AUCTION'){
					$(this.el).find('.currentPickRoundLabel').hide();
					$(this.el).find('.currentPickNumLabel').hide();
					$(this.el).find('.currentPickNominateLabel').show();
				}			
			}
		},
		
		render: function () {
			var team = this.leagueInstance.getTeam(this.draftStatus.get('draftingTeamId'));
			var teamName = team.get('teamName');
			var teamOwner = this.leagueInstance.get("leagueUsers").get(team.get('leagueUserId')).prettyDispName();
			var ovrPickNum = 0;
			
			
			
			if(this.prodConfig.TRIAL == 'true' && this.draftStatus.get('round') > parseInt(this.prodConfig.TRIALRDS)){
				teamName = 'Trial Completed';
			}
			
			if(this.leagueInstance.get('draftType') == 'AUCTION'){
				ovrPickNum = this.draftStatus.get('round') + '.' + this.draftStatus.get('posInRound');
				
				if(!this.draftStatus.get('auctionBidding')){
					$(this.el).find('.currentPickNumLabel').html('<strong>Nominating Pick: </strong>' + ovrPickNum);
				} else {
					$(this.el).find('.currentPickNumLabel').html('<strong>Bidding for Pick: </strong>' + ovrPickNum);
				}
			} else {
				var pickSum = this.pickSummaryCollection.get(this.pickSummaryCollection.getPosRoundId(this.draftStatus.get('round'), this.draftStatus.get('posInRound')));
				ovrPickNum = pickSum.get('ovrPickNum');
				$(this.el).find('.currentPickRoundLabel').html('<strong>Round: </strong>' + this.draftStatus.get('round'));
				$(this.el).find('.currentPickRoundLabel').show();
				$(this.el).find('.currentPickNumLabel').html('<strong>Pick: </strong>' + ovrPickNum);
			}			
			
			$(this.el).find('.currentPickUserLabel').html('User: ' + teamOwner);
			$(this.el).find('.currentPickTeamLabel').html(teamName);
			
			this.pickOwnerRender();
			
			return this;
		},
		
		pickOwnerRender: function () {
			var displayDraftBtn = false;
			var pickTeam = 0;
			
			if(this.leagueInstance.get('draftType') != 'AUCTION'){
				var pickSum = this.pickSummaryCollection.get(this.pickSummaryCollection.getPosRoundId(this.draftStatus.get('round'), this.draftStatus.get('posInRound')));
				if(pickSum && (this.prodConfig.TRIAL == 'false' || this.draftStatus.get('round') <= parseInt(this.prodConfig.TRIALRDS))){
					displayDraftBtn = true;
					pickTeam = pickSum.get('fantasyTeamId');
				}
			} else {
				if(!this.pickSummaryCollection.isAuctionComplete() && !this.draftStatus.get('auctionBidding')){
					displayDraftBtn = true;
					pickTeam = this.draftStatus.get('draftingTeamId');
				}
			}
			
			//Make sure the pick sum is found and that this isn't past the trial range
			if(displayDraftBtn){
				var teamOwner = this.leagueInstance.getTeamOwner(pickTeam);
				var userName = this.user.get('userName');
				var isAssistant = this.leagueInstance.isAssistant(userName);
				
				//Change color of button for commish
				if(isAssistant && userName.toUpperCase() != teamOwner.toUpperCase()){
					this.draftBtn.removeClass('btn-success');
					this.draftBtn.addClass('btn-info');
				} else {
					this.draftBtn.removeClass('btn-info');
					this.draftBtn.addClass('btn-success');
				}
				
				if(isAssistant || userName.toUpperCase() == teamOwner.toUpperCase()){
					this.shareBtnContainer.hide();
					this.draftBtnContainer.show();
				} else {
					this.draftBtnContainer.hide();
					this.shareBtnContainer.show();
				}
			} else {
				this.draftBtnContainer.hide();
				this.shareBtnContainer.show();
			}
		}
	});
	
	return HeaderInfoView;  
});